import {REQUEST} from "../../../util/Request";
import * as types from "./types";

export const consultarCodigoGTMReducer = (state = {}, action) => {
  switch (action.type) {
    case types.CONSULTAR_CODIGO_GTM:
      return {
        ...state,
        estadoConsultarCodigoGTM: REQUEST.PENDING,
        errorConsultarCodigoGTM: undefined,
      };
    case types.CODIGO_GTM_CONSULTADO:
      return {
        ...state,
        estadoConsultarCodigoGTM: REQUEST.SUCCESS,
        errorConsultarCodigoGTM: undefined,
        codigoGTM: action.codigo
      };
    case types.ERROR_CONSULTANDO_CODIGO_GTM:
      return {
        ...state,
        estadoConsultarCodigoGTM: REQUEST.ERROR,
        errorConsultarCodigoGTM: action.error
      };
    default:
      return state;
  }
};
